import $ from "jquery";

import GeneralKenticoForm from './form-general-kentico';

class PriorityListForm extends GeneralKenticoForm
{
    /**
     * Add post data specific to this form to the given postData. This method is called
     * prior to posting the data.
     * @param {object} postData - post data object to add post data to 
     */
    addPostData(postData) {
        if ($(this.config.additionalDataFieldIds.BuyNewSellCurrentRadio).val() == 'Yes')
        {
            postData["SellCurrentBuyNew"] = true;
        } else {
            postData["SellCurrentBuyNew"] = false;
        }

        postData["NewHomePlanPreference"] = $(this.config.additionalDataFieldIds.PlanPreference).val();
        postData["NewHomeSiteNumberPreference"] = $(this.config.additionalDataFieldIds.NewHomeSiteNumberPreference).val();        

        postData["HowToFinanceNewHome"] = $(this.config.additionalDataFieldIds.FinanceOptions).val();
        postData["PrimaryOrSecondary"] = $(this.config.additionalDataFieldIds.PrimaryOrSecondaryResidence).val();

        postData["State"] = $(this.config.additionalDataFieldIds.StateSelector).val();
        postData["Country"] = $(this.config.additionalDataFieldIds.CountrySelector).val();

        return postData;
    }

    /**
     * 
     * @param {object} config - {
     *      submitConfirmationContainer: JQuery selector syntax for the confirmation message
     *      form: JQuery selector for the lead form
     *      isPreviewEnabled: bool true if viewing the page in the cms admin pagebuilder
     * 
     *      postUrlPath: URL path to post the lead to.
     *      formId: Unique identifier for this form instance.
     *      reasonForContactDropdown: JQuery selector selector syntax for the inquiry options.
     * }
     */
    constructor(config) {
        super(config);
        super.getPostDataCallback = this.addPostData;
        super.transformFieldsCallback = this.transformFields;

        this.config = config;
        this.populateCountrySelect(config.additionalDataFieldIds.CountrySelector);
        this.populateStateSelect(config.additionalDataFieldIds.StateSelector, true, false); // params -> (id, addUSStates, addCanadianProvinces)
        this.countrySelect = $(config.additionalDataFieldIds.CountrySelector);
        this.countrySelect.data('formId', config.form);
        this.countrySelect.data('addressFieldSelector', config.additionalDataFieldIds.AddressFieldSelector);
        this.countrySelect.data('stateSelector', config.additionalDataFieldIds.StateSelector);
        this.countrySelect.data('formObj', this);
        this.countrySelect.on('change', this.onCountrySelectChange);

        var caPostalCodeFields = $(config.form).find(config.additionalDataFieldIds.AddressFieldSelector + ".ca-postal-code");
        // hide the CA Postal Code Field
        if (caPostalCodeFields) { 
            caPostalCodeFields.hide();
            caPostalCodeFields.find("input").prop( "disabled", true );
        }
    }

    /**
     * Transforms the shape of the fields to match endpoint model
     * @returns fields - if no transform is needed, returns the fields parameter,
     * otherwise returns the transformed fields
     */
    transformFields(fields) {
        let clsInstance = this;

        if (clsInstance.config.formId == "prioritylist") {
            fields["Buyer"] = {
                "FirstName": fields["BuyerFirstName"],
                "MiddleName": fields["BuyerMiddleName"],
                "LastName": fields["BuyerLastName"],
                "Email": fields["BuyerEmail"],
                "Phone": fields["BuyerPhone"]
            };
            fields["CoBuyer"] = {
                "FirstName": fields["CoBuyerFirstName"],
                "MiddleName": fields["CoBuyerMiddleName"],
                "LastName": fields["CoBuyerLastName"],
                "Email": fields["CoBuyerEmail"],
                "Phone": fields["CoBuyerPhone"]
            };
            fields["CurrentAddress"] = {
                "Country": fields["Country"],
                "Street": fields["Street"],
                "City": fields["City"],
                "State": fields["State"],
                "Zip": fields["Zip"]
            };
            fields["Preferences"] = {
                "SellCurrentBuyNew": fields["SellCurrentBuyNew"],
                "NewHomePlanPreference": fields["NewHomePlanPreference"],
                "NewHomeSiteNumberPreference": fields["NewHomeSiteNumberPreference"],
                "HowToFinanceNewHome": fields["HowToFinanceNewHome"],
                "PrimaryOrSecondary": fields["PrimaryOrSecondary"]
            };
            fields["EmailInfo"] = {
                "Subject": fields["EmailInfoSubject"],
                "Content": fields["EmailInfoContent"],
                "CommunityName": fields["EmailInfoCommunityName"]
            };

            // Send the Canadian Postal Code in the Zip field
            if (fields["Country"].startsWith("Canada"))
            {
                fields["CurrentAddress"].Zip = fields["PostalCode"];
            }
            else if (fields["Country"].startsWith("United States") == false)
            {
                fields["CurrentAddress"].State = "";
            };

            // Remove the name value pairs not set above
            // SFCommunityName needs to be sent, but not explicity set above
            let keyToRemove = Object.keys(fields).filter(key =>
                key !== "GAData" &&
                key !== "Buyer" &&
                key !== "CoBuyer" &&
                key !== "CurrentAddress" &&
                key !== "Preferences" &&
                key !== "EmailInfo" &&
                key !== "SFCommunityName");
            keyToRemove.forEach(key => delete fields[key]);
        }
        return fields;
    }

    /*
    * Country Selection change handler.  Show and Hides the US Zip Code or CA Postal Code field
    * Non-US and Non-Canadian selection hides the address fields
    */
    onCountrySelectChange() {
        var formId = $(this).data('formId');
        var addressFieldSelector = $(this).data('addressFieldSelector');
        var usZipCodeFields = $(formId).find(addressFieldSelector + ".us-zip-code");
        var caPostalCodeFields = $(formId).find(addressFieldSelector + ".ca-postal-code");
        var addressFields = $(formId).find(addressFieldSelector);
        var stateSelector = $(this).data('stateSelector');
        var stateSelect = $(stateSelector);
        var formObj = $(this).data('formObj');
        
        if ($(this).val().startsWith("United States") || $(this).val().startsWith("Canada")) {
            addressFields.show();
            addressFields.find("input").prop( "disabled", false );
            addressFields.find("select").prop( "disabled", false );

            if ($(this).val().startsWith("United States"))
            {
                stateSelect.empty(); // removes the options
                formObj.populateStateSelect(stateSelector, true, false);
                formObj.showEnableFields(usZipCodeFields, true);
                formObj.showEnableFields(caPostalCodeFields, false);
            }
            else// canada selected
            {
                stateSelect.empty(); // removes the options
                formObj.populateStateSelect(stateSelector, false, true);
                formObj.showEnableFields(usZipCodeFields, false);
                formObj.showEnableFields(caPostalCodeFields, true);
            }
        } else {

            addressFields.hide();
            addressFields.find("input").prop( "disabled", true ); // disable it so it's not validated
            addressFields.find("select").prop( "disabled", true );
        }
    }

    showEnableFields(fields, show) {
        if (show && fields) {
            fields.show();
            fields.find("input").prop( "disabled", false );
        }
        if (!show && fields) {
            fields.hide();
            fields.find("input").prop( "disabled", true );
        }
    }
}

export { PriorityListForm as default }
